module.exports = __webpack_public_path__ + "static/media/img-5.9266ed5d.jpg";